import React from 'react';
import { useWatch, UseFormReturn } from 'react-hook-form';
import { EventPanelFormType, EventPanelOptions } from '@mark43/cad-api';
import { Box } from '@cad-arc';
import { TabSubtitle } from '../../../../panels/entity-panels/tabs/tab-subtitle';
import { PropertyBaseKey } from '../types';
import { EventPanelFormPropertyFields } from './event-panel-form-property-fields';

export type EventPanelFormPropertyBoxProps = {
    eventForm: UseFormReturn<EventPanelFormType>;
    eventPanelOptions: EventPanelOptions;
    showTitle?: boolean;
    baseKey: PropertyBaseKey;
    propertyLabel: string;
    noMembersText?: string;
    addButtonText?: string;
    hideDexFields?: boolean;
} & (
    | {
          allowMembersControl: true;
          addButtonText: string;
      }
    | {
          allowMembersControl?: false;
      }
);

export function InvolvedPropertyBox({
    eventForm,
    baseKey,
    propertyLabel,
    noMembersText,
    addButtonText,
    eventPanelOptions,
    allowMembersControl,
    hideDexFields,
}: EventPanelFormPropertyBoxProps): React.ReactElement {
    const involvedPropertyItem = useWatch({
        control: eventForm.control,
        name: baseKey,
    });
    const addText = addButtonText ? addButtonText : '';
    return (
        <Box pt={baseKey === 'firearms' ? 0 : 4}>
            <TabSubtitle>
                {propertyLabel} ({involvedPropertyItem ? involvedPropertyItem.length : 0})
            </TabSubtitle>
            <EventPanelFormPropertyFields
                displayAsCards
                form={eventForm}
                eventPanelOptions={eventPanelOptions!}
                hideDexFields={hideDexFields}
                allowMembersControl={allowMembersControl}
                baseKey={baseKey}
                addButtonText={addText}
                noMembersText={noMembersText}
            />
        </Box>
    );
}
